/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ArchiveCompaniesRequest
 */
export interface ArchiveCompaniesRequest {
  /**
   *
   * @type {boolean}
   * @memberof ArchiveCompaniesRequest
   */
  archive?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof ArchiveCompaniesRequest
   */
  ids?: Array<string>
}

export function ArchiveCompaniesRequestFromJSON(json: any): ArchiveCompaniesRequest {
  return ArchiveCompaniesRequestFromJSONTyped(json, false)
}

export function ArchiveCompaniesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArchiveCompaniesRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    archive: !exists(json, 'archive') ? undefined : json['archive'],
    ids: !exists(json, 'ids') ? undefined : json['ids']
  }
}

export function ArchiveCompaniesRequestToJSON(value?: ArchiveCompaniesRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    archive: value.archive,
    ids: value.ids
  }
}
